import { useEffect, useState } from 'react';
import { useParams, useNavigate, useSearchParams, Link, useLocation } from 'react-router-dom';
import dompurify from 'dompurify'

import Spinner from 'react-bootstrap/Spinner';
import Image from 'react-bootstrap/Image';

import Menu from '../../components/MenuA2A2';
import Botao from '../../components/Botao';
import CardProdutoA2A2 from '../../components/CardProdutoA2A2';
import Divisor from '../../components/Divisor';
import Imagens from '../../components/Imagens';
import Noticias from '../../components/Noticias';
import Videos from '../../components/Videos';

import constantes from '../../helpers/constanteHelper';

import sheetsService from '../../services/sheetsServiceA2A2'


function DadosProdutoA2A2() {
    const [width, setWidth] = useState(window.innerWidth);
    const [produto, setProduto] = useState({})
    const sanitizer = dompurify.sanitize

    const location = useLocation()

    // Controle de idioma
    const [idioma, setIdioma] = useState('pt')

    const [searchParams, setSearchParams] = useSearchParams();

    const navigate = useNavigate();

    const { slug } = useParams();

    // Controle de carregamento da tela
    const [telaCarregada, setTelaCarregada] = useState(false)

    function separarItensDesseIdioma(tipoItem) {
        return produto[tipoItem]?.filter((item) => {
            if (idioma === 'pt') {
                return item['Português']?.toUpperCase() === 'X'
            } else if (idioma === 'en') {
                return item['Inglês']?.toUpperCase() === 'X'
            } else if (idioma === 'es') {
                return item['Espanhol']?.toUpperCase() === 'X'
            } else if (idioma === 'fr') {
                return item['Francês']?.toUpperCase() === 'X'
            }
        })
    }

    function observarMudancaWidth() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        sheetsService.buscarDadosProdutosSemSeparacaoPorEmpresa().then((produtosBuscados) => {
            for (let i = 0; i < produtosBuscados.length; i++) {

                if (produtosBuscados[i]['Slug (Url)'] === slug) {
                    setProduto(produtosBuscados[i])
                    setTelaCarregada(true)
                }
            }
        })
        window.addEventListener('resize', observarMudancaWidth);

        // Scroll para o topo da página para melhor visualização no mobile ou em resoluções menores
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })

        return () => {
            window.removeEventListener('resize', observarMudancaWidth);
        }
    }, []);

    const resolucaoMobile = width <= constantes.RESPONSIVIDADE.LARGURA_MOBILE;

    const regraExibicaoMenu = searchParams.get('menu')

    return (
        <>
            {telaCarregada ? <div style={{ padding: resolucaoMobile ? '0px 5px 0px 5px' : '0px', minHeight: '100vh', background: constantes.CORES.AZUL_A2A2 }} className='text-center d-flex flex-column align-items-center'>
                {regraExibicaoMenu === 'false' ? <></> : <Menu opcaoSelecionada={'produtos'} />}
                {regraExibicaoMenu === 'false' ? <div className='mt-3'><Botao funcao={() => { navigate(`/catalogo-a2a2/marcas/${produto['Slug Empresa']}?menu=false`) }} largura={260} corTexto={constantes.CORES.AZUL_A2A2} cor={constantes.CORES.BRANCO_PADRAO} texto={'Voltar para empresa'} icone={'voltar'} /></div> : <></>}

                <div className='mt-5'></div>
                <div className='mt-5'></div>

                <CardProdutoA2A2 produto={produto} desativarLink={regraExibicaoMenu === 'false'} />

                <h1 className='mt-5 me-2 ms-2' style={{ color: constantes.CORES.BRANCO_PADRAO, fontWeight: 700 }}>{produto['Nome do produto/serviço']}</h1>

                <span className='mb-5' style={{ fontSize: '20px', textAlign: 'center', color: constantes.CORES.BRANCO_PADRAO }}>{produto['Empresa']}</span>

                <span className='mb-5' style={{ fontSize: '18px', textAlign: 'center', color: constantes.CORES.BRANCO_PADRAO, marginLeft: '10px', marginRight: '10px' }}><strong>Categoria:</strong> {produto['Categoria']}</span>
                <div className='mt-2'></div>

                <Botao funcao={() => { regraExibicaoMenu === 'false' ? navigate(`/catalogo-a2a2/marcas/${produto['Slug Empresa']}?menu=false&pontos=true`) : navigate(`/catalogo-a2a2/marcas/${produto['Slug Empresa']}?pontos=true`) }} cor={constantes.CORES.BRANCO_PADRAO} corTexto={constantes.CORES.AZUL_A2A2} largura={380} icone={'pontosVenda'} texto={'Ver pontos de venda da marca'} />

                <div className='mt-5'></div>
                <Divisor />

                <div dangerouslySetInnerHTML={{ __html: sanitizer(produto['Descrição do produto']) }} className='mt-5 mb-5' style={{ width: resolucaoMobile ? '90vw' : '70vw', color: constantes.CORES.BRANCO_PADRAO, fontSize: resolucaoMobile ? '16px' : '20px', whiteSpace: 'pre-line', textAlign: resolucaoMobile ? 'justify' : 'center', }}></div>

                {produto['Link para imagem adicional'] ? <Image className='mb-5' style={{ borderRadius: '10px', maxWidth: resolucaoMobile ? '90vw' : '100vw', objectFit: 'contain' }} src={produto['Link para imagem adicional']} alt='logo' fluid /> : <></>}

                {produto['Link para mais informações'] ? <Link className='mb-3' style={{ textDecoration: 'none' }} to={produto['Link para mais informações']} target='_blank' rel='noopener noreferrer'>
                    <Botao cor={constantes.CORES.BRANCO_PADRAO} corTexto={constantes.CORES.AZUL_A2A2} largura={300} icone={'buscar'} texto={'Mais informações'} />
                </Link> : <></>}

                {produto['Link para a bula'] ? <Link className='mb-5' style={{ textDecoration: 'none' }} to={produto['Link para a bula']} target='_blank' rel='noopener noreferrer'>
                    <Botao cor={constantes.CORES.BRANCO_PADRAO} corTexto={constantes.CORES.AZUL_A2A2} largura={300} icone={'bula'} texto={'Bula'} />
                </Link> : <></>}

                {produto['Vídeos'] ? <><Divisor />
                    <Videos item={produto} resolucaoMobile={resolucaoMobile} idioma={idioma} /></>
                    : <></>}

                {produto['Imagens'] && separarItensDesseIdioma('Imagens').length > 0 ? <>
                    <Divisor />
                    <Imagens imagens={separarItensDesseIdioma('Imagens')} resolucaoMobile={resolucaoMobile} idioma={idioma} /></> :
                    <></>}

                {produto['Notícias'] && separarItensDesseIdioma('Notícias').length > 0 ? <>
                    <Divisor />
                    <Noticias noticias={separarItensDesseIdioma('Notícias')} resolucaoMobile={resolucaoMobile} idioma={idioma} /></> :
                    <></>}

                <div className='mt-5'></div>

            </div> : <div style={{ minHeight: '100vh', background: constantes.CORES.AZUL_A2A2 }} className='d-flex flex-column align-items-center'>
                <div style={{ height: '100vh', gap: '20px' }} className='mt-5 d-flex flex-column align-items-center justify-content-center text-center'>
                    <Spinner style={{ height: '60px', width: '60px' }} variant='light' />
                    <span className='mt-3' style={{ fontSize: '20px', color: constantes.CORES.BRANCO_PADRAO, paddingLeft: '20px', paddingRight: '20px' }}>Carregando dados...<br />Por gentileza, aguarde alguns instantes.</span>
                </div>
            </div>}
        </>
    );
}

export default DadosProdutoA2A2;
